import {
  Button,
  CardContent,
  CardHeader,
  Grid,
  MapIcon
} from "@dealer-center/core-components";
import {
  PagesLandingPageListItem,
  StyledUnorderedList
} from "@dealer-center/ddc-core-custom-components";
import { StyledCard } from "./styledCard";
import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import { useOutletContext } from "react-router-dom";
import type { IDashboardProps } from "@dealer-center/ddc-pages-dashboard-interface";

export const DealerAddress = (props: IDashboardProps) => {
  const { isEdit } = props;
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();

  return (
    <Grid size={!isEdit ? { lg: 3, sm: 6, xs: 12 } : 12}>
      <StyledCard
        content={
          <CardContent>
            <StyledUnorderedList>
              <PagesLandingPageListItem
                label="Street"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.address.address1}
              />
              <PagesLandingPageListItem
                label="Street 2"
                value={accountEntity.address.address2}
              />
              <PagesLandingPageListItem
                label="Street 3"
                value={accountEntity.address.address3}
              />
              <PagesLandingPageListItem
                label="City"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.address.city}
              />
              <PagesLandingPageListItem
                label="State"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.address.state}
              />
              <PagesLandingPageListItem
                label="Postal Code"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.address.postalCode}
              />
              <PagesLandingPageListItem
                label="Country"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.address.country}
              />
              <Button
                analyticsConfiguration={{
                  eventName: "open_map"
                }}
                buttonStyle="secondary"
                size="small"
                startIcon={<MapIcon title="Map Location" />}
                onClick={() => {
                  window.open(
                    `https://maps.google.com/?q=${accountEntity.properties.latitude},${accountEntity.properties.longitude}`
                  );
                }}
              >
                Map Location
              </Button>
            </StyledUnorderedList>
          </CardContent>
        }
        header={<CardHeader title="Dealer Address" />}
      />
    </Grid>
  );
};
